export default __webpack_public_path__ + "static/media/PrafullAnubhai.c303af5d.png";